module.exports = __webpack_public_path__ + "static/media/golf-week-light.40649fb1.svg";